<script setup>
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { messageStamp } from 'shared/helpers/timeHelper';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  inboxName: { type: String, default: '' },
  inboxIcon: { type: String, default: '' },
  scheduledAt: { type: Number, default: 0 },
  counts: { type: Object, default: () => ({}) },
  templateStatus: { type: String, default: '' },
});

const { t } = useI18n();

const countFor = key => props.counts?.[key] || 0;
</script>

<template>
  <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
    {{ t('CAMPAIGN.WHATSAPP.CARD.CAMPAIGN_DETAILS.SENT_FROM') }}
  </span>
  <div class="flex items-center flex-shrink-0 gap-1.5">
    <Icon :icon="inboxIcon" class="flex-shrink-0 text-n-slate-12 size-3" />
    <span class="text-sm font-medium text-n-slate-12">{{ inboxName }}</span>
  </div>
  <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
    {{ t('CAMPAIGN.WHATSAPP.CARD.CAMPAIGN_DETAILS.ON') }}
  </span>
  <span class="text-sm font-medium truncate text-n-slate-12">
    {{ messageStamp(new Date(scheduledAt), 'LLL d, h:mm a') }}
  </span>
  <span class="text-sm text-n-slate-11">
    {{ t('CAMPAIGN.WHATSAPP.CARD.CAMPAIGN_DETAILS.SENT') }}
    {{ countFor('sent') }}
  </span>
  <span class="text-sm text-n-slate-11">
    {{ t('CAMPAIGN.WHATSAPP.CARD.CAMPAIGN_DETAILS.DELIVERED') }}
    {{ countFor('delivered') }}
  </span>
  <span class="text-sm text-n-slate-11">
    {{ t('CAMPAIGN.WHATSAPP.CARD.CAMPAIGN_DETAILS.READ') }}
    {{ countFor('read') }}
  </span>
  <span class="text-sm text-n-slate-11">
    {{ t('CAMPAIGN.WHATSAPP.CARD.CAMPAIGN_DETAILS.FAILED') }}
    {{ countFor('failed') }}
  </span>
  <span
    v-if="
      ['PENDING', 'REJECTED'].includes(String(templateStatus).toUpperCase())
    "
    class="text-sm text-n-amber-11"
  >
    {{
      t(
        `CAMPAIGN.WHATSAPP.CARD.TEMPLATE_STATUS.${String(templateStatus).toUpperCase()}`
      )
    }}
  </span>
</template>
